const coerceNumber = (value) => {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  const asNumber = Number(trimmed);
  return Number.isFinite(asNumber) ? asNumber : null;
};

const parseSlashDateToUtcMs = (value) => {
  const parts = value.split("/");
  if (parts.length !== 3) return null;
  const a = Number(parts[0]);
  const b = Number(parts[1]);
  let year = Number(parts[2]);
  if (![a, b, year].every(Number.isFinite)) return null;

  if (year < 100) year = 2000 + year;

  let month = a;
  let day = b;

  if (a > 12 && b <= 12) {
    day = a;
    month = b;
  }

  if (month < 1 || month > 12 || day < 1 || day > 31) return null;
  return Date.UTC(year, month - 1, day);
};

export const parseDateToEpoch = (value) => {
  if (!value) return 0;

  const numeric = coerceNumber(value);
  if (numeric != null) {
    return numeric < 1e12 ? numeric * 1000 : numeric;
  }

  if (typeof value !== "string") return 0;
  const trimmed = value.trim();
  if (!trimmed) return 0;

  const parsed = Date.parse(trimmed);
  if (Number.isFinite(parsed)) return parsed;

  if (trimmed.includes("/")) {
    const slash = parseSlashDateToUtcMs(trimmed);
    if (slash != null) return slash;
  }

  return 0;
};

